export function isRGB (colorStr: string) {
  return /rgb\(\d{1,3}(,\s?\d{1,3}){2}\)/.test(colorStr);
}
